<template>
    <div id="commitmentProgram">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <!-- data-sal="slide-up" data-sal-duration="1000" -->
                <div class="project-add-banner bg-gradient-green">
                    <div class="content">
                        <span class="subtitle bold">Programa Compromiso.</span>
                        <h2 class="font-weight-100">
                            Al activar el interés compuesto 
                            <br>y el abono recurrente
                            <span class="bold">¡podrás reducir tu comisión!</span>
                        </h2>
                        <h6 class="font-weight-100 white">
                        </h6>
                        <button @click.stop="goToPage('suppliersPage')" class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button-black w-auto">Conoce más</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data: () => ({
            drawer: true,
            drawerRight: true,
            right: null,
            left: null
        }),
        props: {
            source: String
        }
    }
</script>

<style>
.btn-dark {
    background-color: var(--color-dark);
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    padding: 10px 30px;
    transition: all 0.3s ease-in-out;
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>